import { types } from "mobx-state-tree";

export const Changelog = types
    .model({
        name: types.string,
        /** Версия для показа: первая в мажоре — «2.0», остальные — «2.26.11.3» */
        display: types.optional(types.string, ""),
        description: types.string,
    })
    .named("Changelog");

export type ChangelogType = typeof Changelog.Type;
